import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class CalendarDialogHttpService {
    constructor(private httpClient: HttpClient) { }

    getSurveyCalendarReport(userAccountId: number, surveyTypes?: string[], surveyInstanceId?: number): Observable<any> {
        const url = ecorEnv.apiEndpoint + '/secure/reports/calendar';
        let params = new HttpParams()
            .set('userAccountId', userAccountId?.toString() || 'undefined')
            .set('fileType', "ics");
        
        // If surveyTypes are provided, use them (they take precedence over surveyInstanceId)
        if (surveyTypes && surveyTypes.length > 0) {
            const surveyTypesStr = surveyTypes.join("+");
            params = params.set('surveyTypes', surveyTypesStr);
        } else if (surveyInstanceId) {
            params = params.set('surveyInstanceId', surveyInstanceId.toString());
        }

        return this.httpClient.get<any>(url, { params: params, responseType: 'blob' as 'json' })
            .pipe(
                catchError(this.handleError)
            );
    }

    sendCalendarReport(userAccountId: number, json: string, fileName: string): Observable<any> {
        const url = ecorEnv.apiEndpoint + '/secure/reports/calendar';
        const params = new HttpParams()
            .set('userAccountId', userAccountId.toString())
            .set('fileType', "ics")
            .set('fileName', fileName);
        return this.httpClient.post<any>(url, json, { params })
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('surveys', 'error', error);
        if (error.error instanceof ErrorEvent) {
            console.error('calendar-dialogs', 'client side error:', error.error.message);
        } else {
            return throwError('Error-111111');
        }
        return throwError('Error-222222');
    }
}
